// External reference ****************************************************************************
// pathname: /v1/job-operation/{jobSlug}/external-reference
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';
import { bjToast } from '@components/common';
import { useTranslation } from 'next-i18next';

interface ExternalReferencePayload {
  externalReference: string | null;
}

/**
 * @description SWR mutation: PATCH the per-job external reference used by applicant-push
 * integrations (e.g. Cegid Talentsoft `offerReference` for McDonald's). Admin-only via
 * impersonation; the backend voter is the source of truth and OwnerJobRead.externalReferenceEditable
 * decides whether the UI exposes the section. Passing `null` clears the reference and makes
 * future pushes skip the job.
 */
export const useSwrPatchExternalReference = (jobSlug: string, locale = 'ro') => {
  const { t } = useTranslation('common');

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, ExternalReferencePayload>({
    url: `/v1/job-operation/${jobSlug}/external-reference`,
    locale,
    fetcherConfig: {
      method: 'PATCH',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        bjToast.success(t('global.label.success'));
      },
      onError: (newError) => {
        if (newError.errors[0]?.message) {
          bjToast.error(newError.errors[0].message);
        }
      },
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
